module.exports = __webpack_public_path__ + "img/Identity.d7732967.svg";